import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL } from '../data/content';
const highlights = ['Comprendé lo que estás sintiendo y reconocé qué querés acompañar.', 'Elegí una práctica concreta según el momento que estés atravesando.', 'Avanzá a tu ritmo: recorré la guía entera o consultá solo una sección.', 'Volvé al material cada vez que aparezca una nueva necesidad.'];
export function GuideSection() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-81" data-mp="2fv7xzc7sswiq">
      <div className="mx-auto grid max-w-5xl items-center gap-8 md:grid-cols-2 md:gap-12" data-id="element-82" data-mp="2krf3x507280o">
        <figure className="order-1 mx-auto w-full max-w-[420px] md:order-none md:max-w-none" data-id="element-83" data-mp="262amvr54y9u5">
          <div className="relative overflow-hidden rounded-[26px] bg-plum p-1.5 shadow-[0_26px_60px_-28px_rgba(52,36,60,0.55)] ring-1 ring-gold/25 sm:p-2" data-id="element-84" data-mp="2b0u8trjqblmi">
            <div className="relative overflow-hidden rounded-[20px]" data-id="element-85" data-mp="33ig41wd1w9lt">
              <img src="https://cdn.magicpatterns.com/patterns/generated-images/a532dd18-df9e-48a0-bdbf-fd5f5deccc81.jpg" alt="Guía de Autocuración Energética de Aura Viva 2026 abierta, mostrando una página interior con ilustraciones y tarjetas de práctica" width="800" height="1000" loading="lazy" decoding="async" sizes="(max-width: 768px) calc(100vw - 40px), 420px" className="block aspect-[4/5] w-full object-cover" data-id="element-86" data-mp="33kj130cmf301" />
              <div className="pointer-events-none absolute inset-0 rounded-[20px] shadow-[inset_0_0_46px_16px_rgba(52,36,60,0.55)]" aria-hidden="true" data-id="element-87" data-mp="1d3fxel2x21hu" />
              <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-inset ring-gold/15" aria-hidden="true" data-id="element-88" data-mp="183jsmjmea618" />
            </div>
          </div>
          <figcaption className="pt-3 text-center text-xs font-medium text-plum/70" data-id="element-89" data-mp="1i1zmguct3tef">
            Vistas interiores de la Guía de Autocuración Energética.
          </figcaption>
        </figure>

        <motion.div initial={{
        opacity: 0,
        y: 18
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="order-2 text-center md:order-none md:text-left" data-id="element-90" data-mp="3jufdle15jfk2">
          <span className="inline-block rounded-full border border-gold/50 bg-card px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-plum" data-id="element-91" data-mp="mck3w8or7fta">
            Guía de Autocuración Energética
          </span>
          <h2 className="mt-4 font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-92" data-mp="wb9b97j0xhva">
            El corazón de Aura Viva 2026
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-93" data-mp="153jn0t9khven">
            Una guía visual para explorar prácticas de autocuidado energético, comprender tus
            intenciones y elegir una herramienta posible para tu momento.
          </p>

          <ul className="mt-6 space-y-3 text-left" data-id="element-94" data-mp="1k13m5jjs8wcw">
            {highlights.map(item => <li key={item} className="flex items-start gap-3" data-id="element-95" data-mp="1k1c3poquopuf">
                <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-gold" aria-hidden="true" data-id="element-96" data-mp="34k5zcij88c2r" />
                <span className="text-sm leading-relaxed text-plum/80" data-id="element-97" data-mp="2zj8kofxfe060">{item}</span>
              </li>)}
          </ul>

          <div className="mx-auto mt-8 w-full max-w-md md:mx-0" data-id="element-98" data-mp="2ulgqtgd803z6">
            <CTAButton label="QUIERO ACCEDER A LA GUÍA COMPLETA" href={CHECKOUT_URL} variant="green" textClassName="text-[13px] tracking-tight sm:text-[15px] sm:tracking-normal" data-id="element-99" data-mp="2pmnhm04yuz4t" />
          </div>
        </motion.div>
      </div>
    </section>;
}